import React from "react";
import useBrand from "hooks/useBrand";
import { useLocalization } from "hooks/useLocalization";
import RHRBabyChildIcon from "@RHCommerceDev/icon-babychild-rhr";
import RHROutdoorIcon from "@RHCommerceDev/icon-outdoor-rhr";
import RHRTeenIcon from "@RHCommerceDev/icon-teen-rhr";
import WORHIcon from "@RHCommerceDev/icon-worh";
import { BRAND_SUBDOMAINS } from "utils/constants";
import { useEnv } from "hooks/useEnv";

const BrandIcons = {
  TN: (
    <RHRTeenIcon className="h-[46px] w-12 text-white sm:h-[57px]  sm:w-[60px] lg:h-16 lg:w-[67px]" />
  ),
  BC: (
    <RHRBabyChildIcon className="h-[46px] w-12 text-white sm:h-[57px]  sm:w-[60px] lg:h-16 lg:w-[67px]" />
  ),
  OD: (
    <RHROutdoorIcon className="h-[46px] w-12 text-white sm:h-[57px]  sm:w-[60px] lg:h-16 lg:w-[67px]" />
  ),
  RH: (
    <WORHIcon
      className="h-[46px] w-12 sm:h-[57px] sm:w-[60px]  lg:h-16 lg:w-[67px] "
      fillColor={"white"}
    />
  )
};

const BrandLogo = () => {
  const brand = useBrand();
  const locale = useLocalization();
  const env = useEnv();

  const hostname = env.REACT_APP_ATG_HOST_NAME;

  const getBrandUrl = brand => {
    if (brand in BRAND_SUBDOMAINS) {
      const subdomain =
        BRAND_SUBDOMAINS[brand as keyof typeof BRAND_SUBDOMAINS];
      return `https://${subdomain}.${hostname}${locale}`;
    }

    return `https://${hostname}${locale}`;
  };

  const getBrandIcon = brand => {
    const brandIcon =
      brand in BrandIcons
        ? BrandIcons[brand as keyof typeof BrandIcons]
        : BrandIcons.RH;
    return brandIcon;
  };

  return (
    <a href={getBrandUrl(brand)} className="block h-min w-min">
      {getBrandIcon(brand)}
    </a>
  );
};

export default BrandLogo;
